import { render, staticRenderFns } from "./knowledgeDetail.vue?vue&type=template&id=4f03fd24&scoped=true"
import script from "./knowledgeDetail.vue?vue&type=script&lang=js"
export * from "./knowledgeDetail.vue?vue&type=script&lang=js"
import style0 from "./knowledgeDetail.vue?vue&type=style&index=0&id=4f03fd24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03fd24",
  null
  
)

export default component.exports